import wx from 'weixin-js-sdk';
import API from '../api/api'
import {getFetch, postFetchBody, postFetchParams,} from '../utils/getData'
import Cookies from "js-cookie";

/* eslint-disable no-undef */
// 微信注入依赖config校验
export function getWxConfig (url) {
  let FRONT_BASE = url || `${location.href}`;
  console.log(FRONT_BASE,location.href,'---------------');

  let postData = {url: FRONT_BASE, source:"weixin"};
  // let wx_cfg = Cookies.get('WX_CONFIG');
  // if(!wx_cfg){

    postFetchBody(API.weChatSdk, postData, undefined, false).then(response => {
      console.log(response.data);
      let res = response.data;
      if (res.code !== 1) {
        // this.$vux.toast.show(res.msg);
        return;
      }

      wx.config({
        debug: false, // 开启调试模式,
        appId: res.data.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
        timestamp: res.data.timestamp, // 必填，生成签名的时间戳
        nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
        signature: res.data.signature,// 必填，签名，见附录1
        jsApiList: ['checkJsApi', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'hideMenuItems'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      });
      // var inFifteenMinutes = new Date(res.data.timestamp + 50 * 60 * 1000);
      // Cookies.set('WX_CONFIG', JSON.stringify(res.data), {expires: inFifteenMinutes});
    }).catch(err => {
      console.warn(err);
      console.log('获取授权失败')
    })
  // }else{
  //   console.log('----------getcookie--------');
  //   let wx_cfg_obj = JSON.parse(wx_cfg);
  //   wx.config({
  //     debug: false, // 开启调试模式,
  //     appId: wx_cfg_obj.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
  //     timestamp: wx_cfg_obj.timestamp, // 必填，生成签名的时间戳
  //     nonceStr: wx_cfg_obj.nonceStr, // 必填，生成签名的随机串
  //     signature: wx_cfg_obj.signature,// 必填，签名，见附录1
  //     jsApiList: ['checkJsApi', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'hideMenuItems'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
  //   });
  // }

}

// 微信分享配置 显示微信浏览器右边菜单中的显示所有功能按钮接口
export function wxShare (url, isblack,title, desc, imgUrl) {
  // let FRONT_BASE = !isblack ? url : `${location.protocol}//${location.host}/index`;
  let FRONT_BASE = `${location.protocol}//${location.host}/index`;
  console.log('FRONT_BASE',FRONT_BASE);

  let ICON_BASE = `${location.protocol}//${location.host}`;
  let shareData = {
    title: '佳之易充值中心',
    desc: '玖佰充值平台，致力于成为国内最具竞争力的全种类数字产品支付服务平台，平台现已开通微信支付，支付宝支付，银联支付等多种支付渠道。在投入市场十多年以来，凭借全面的的产品种类，安全的交易环境，便捷的支付方式等特点，赢得了广大用户的一致好评。',
    link: FRONT_BASE,
    imgUrl: ICON_BASE+'/static/favicon.jpg',
    success: function () {
      // 用户确认分享后执行的回调函数
    },
    cancel: function () {
      // 用户取消分享后执行的回调函数
    }
  };

  wx.ready(function () {
    // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
    wx.onMenuShareAppMessage(shareData);
    wx.onMenuShareTimeline(shareData);

    //只能隐藏“传播类”和“保护类”按钮
    // aliMiddle，这个页面不能隐藏
    if (!(url.indexOf("aliMiddle") !== -1)){
      wx.hideMenuItems({
        menuList: [
          'menuItem:copyUrl', //基础类 菜单不能隐藏
          'menuItem:openWithSafari'
        ]
      });
    }
  });

  wx.error(function (res) {
    // alert(res.errMsg);
  });

}




// WEBPACK FOOTER //
// ./src/utils/wechatConfig.js